export const Config = {
  apiUrl: window.location.origin,
  // reCAPTCHASiteKey: "6Lcvmq8qAAAAALwcYHhcrknbVqh1Flfv73SpgzSQ", //local
    reCAPTCHASiteKey: "6Lefmq8qAAAAAO531Y1_9E2Yp7j9Gd3-VotbeJTb", //dev
  // reCAPTCHASiteKey: "6Leumq8qAAAAAM6Jfvb86ooVBqUV_n9_Fw6uxjWi"   //prod
};
